import { useLocation } from "react-router-dom";

import { useAppState } from "@/components/AppStateProvider";
import LoggedOutNavigation from "@/components/navigation/common/LoggedOutNavigation";
import PatientLoggedInNavigation from "@/components/navigation/patient/PatientLoggedInNavigation";
import { HeaderProvider } from "@/contexts/HeaderContext";
import {
  CMP_DASHBOARD_URL,
  getCmpUrl,
  getWardUrl,
  SETTINGS_URL,
  WARDS_TESTS_URL
} from "@/core/urls";
import useAvailableOrganisations from "@/hooks/organisations/useAvailableOrganisations";
import { startsWith } from "@/utils/nodash";

import Container from "./Container";

const EXCEPTIONS = [];

function useHeader() {
  const location = useLocation();
  return !EXCEPTIONS.includes(location.pathname);
}

export default function B2CHeader({ hideNav = false }) {
  const { userInfo } = useAppState();
  const showHeader = useHeader();
  const [availableOrganisations] = useAvailableOrganisations();

  let header = <Container bg="blue" height={60} />;

  if (!showHeader) {
    return null;
  }

  if (userInfo) {
    header = userInfo.user ? (
      <PatientLoggedInNavigation
        accounts={[
          {
            label: "Personal Health Data",
            links: [
              {
                label: `${userInfo.user.firstName} ${userInfo.user.lastName}`,
                to: SETTINGS_URL,
                activeTest: () => {
                  return !startsWith(location.pathname, "/patients");
                }
              },
              ...(userInfo.user.patientProfile?.wards ?? []).map(ward => ({
                label: `${ward.user.firstName} ${ward.user.lastName}`,
                href: getWardUrl(WARDS_TESTS_URL, { patientId: ward.user.id }),
                newTab: true,
                activeTest: () => {
                  return startsWith(location.pathname, `/patients/${ward.user.id}`);
                }
              }))
            ]
          },
          {
            label: "Organisations",
            links:
              availableOrganisations?.map(organisation => ({
                label: organisation.name,
                to: getCmpUrl(CMP_DASHBOARD_URL, { organisationId: organisation.hashId }),
                activeTest: () => {
                  return startsWith(location.pathname, `/cmp/organisations/${organisation.hashId}`);
                }
              })) || []
          }
        ]}
        hideNav={hideNav}
      />
    ) : (
      <LoggedOutNavigation />
    );
  }

  return <HeaderProvider>{header}</HeaderProvider>;
}
